<template>
   <div class="bg-seconday mx-auto w-full max-w-xs items-center justify-center">
      <div class="mb-2 w-full shrink-0">
         <a ref="outlookLink" href="https://outlook.live.com/mail/" class="mail-link text-sm">
            <IconOutlook class="relative -ml-1 shrink-0" style="right: 2px" />
            <span class="relative" style="left: 4px">{{ $t("redirects.open_link", { link: "Outlook" }) }}</span>
         </a>
      </div>
      <div class="mb-2 w-full shrink-0">
         <a href="https://mail.google.com/mail/" class="mail-link text-sm">
            <IconGmail class="relative -ml-1 shrink-0" style="right: 2px" />
            <span class="relative" style="left: 4px">{{ $t("redirects.open_link", { link: "Gmail" }) }}</span>
         </a>
      </div>
      <div class="mb-2 w-full shrink-0">
         <a href="https://mail.yahoo.com" class="mail-link text-sm">
            <IconYahoo class="relative -ml-1 shrink-0" style="right: 2px" />
            <span class="relative" style="left: 4px">{{ $t("redirects.open_link", { link: "Yahoo" }) }}</span>
         </a>
      </div>

      <p class="mx-auto mt-10 md:w-3/4">{{ $t("system.email_check_spam_folder") }}</p>
   </div>
</template>

<script setup lang="ts">
import { useI18n } from "@/vue-i18n/vue-i18n";

const { t: $t } = useI18n();
const outlookLink = ref(null);

// onMounted set focus to the Outlook link
onMounted(() => {
   outlookLink.value.focus();
});
</script>

<style scoped>
.mail-link {
   @apply relative border rounded-full px-6 py-4 leading-tight inline-flex justify-center items-center w-full;
   border-color: var(--colour-border-base);
}
</style>
